<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-form ref="addressForm">
      <v-container fluid class="mt-4">
        <v-row class="mb-4">
          <v-col>
            <h2>{{ $t("basics.edit", { type: $t("basics.address") }) }}</h2>
          </v-col>
        </v-row>
        <AddressComponentVue
          :addressData="addressCopy"
          :isBirthplace="isBirthplace"
          :isLocationEdit="isLocationEdit"
          :dense="dense"
          :required="required"
          :autosave="autosave"
          :showPremise="showPremise"
          :readonly="readonly"
          :cardMode="cardMode"
        />

        <v-row>
          <v-col>
            <v-btn
              large
              block
              flat
              class="primaryButton"
              @click="confirm()"
              ref="confirmButton"
            >
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </DrawerVue>
</template>

<script>
import AddressComponentVue from "./AddressComponent.vue";

export default {
  name: "addressDrawerComponent",

  props: {
    addressData: {},
    userData: {},
    isBirthplace: { default: false },
    isLocationEdit: { default: false },
    dense: { default: false },
    required: {
      default: true,
    },
    autosave: { default: false },
    showPremise: { default: false },
    readonly: { default: false },
    cardMode: { default: false },
    refreshDisplay: { default: 0 },
  },

  emits: ["close", "refresh"],

  data() {
    return {
      addressCopy: {},
    };
  },

  components: {
    AddressComponentVue,
  },

  watch: {
    refreshDisplay() {
      this.addressCopy = JSON.parse(JSON.stringify(this.addressData));
    },
  },

  methods: {
    async confirm() {
      const { valid } = await this.$refs.addressForm.validate();

      if (valid) {
        let formData = {};

        if (this.isBirthplace) {
          formData["birth_place"] = this.addressCopy;
        } else {
          formData["address"] = this.addressCopy;
          if (typeof formData.address.city.zip_code == "object") {
            formData.address.city.zip_code = formData.address.city.zip_code.key;
          }
        }

        formData["id"] = this.userData.id;

        this.patchData(formData);
      }
    },
    patchData(formData) {
      this.axios
        .patch(this.axios.defaults.baseURL + "user/users/patch/" + formData.id, formData)
        .then((resp) => {
          this.$emit("close", 1);
          this.$emit("refresh", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
  },
};
</script>
